import PropTypes from 'prop-types';
import OutlinedPillButton from '../shared/button/OutlinedPillButton';
import Text from '../Text';
import { SHARE } from '../../constants/localizations/profile';

const ShareButton = ({ toggleShareDialog, className }) => (
  <OutlinedPillButton
    id="shareButton"
    dataTestId="profileShare"
    onClick={toggleShareDialog}
    className={className}
    label={<Text name={SHARE} />}
  />
);

ShareButton.propTypes = {
  toggleShareDialog: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default ShareButton;
